import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { ITenderDashboardData } from 'types/tender/tenderDashboard'

type Props = {
  dashboardData: ITenderDashboardData
}

export const DashboardGeneralInfo = ({ dashboardData }: Props) => {
  const { t } = useTranslation()
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-evenly',
          background: '#fff',
          borderRadius: '4px',
          padding: '20px 0',
          margin: '25px 0',
        }}
      >
        <Box sx={{ textAlign: 'center' }}>
          <Typography sx={{ fontWeight: 'bold', fontSize: '18px' }}>
            {dashboardData.planningTenderCount}
          </Typography>
          <Typography>{t('future-contests')}</Typography>
        </Box>
        <Box sx={{ textAlign: 'center' }}>
          <Typography sx={{ fontWeight: 'bold', fontSize: '18px' }}>
            {dashboardData.ongoingTenderCount}
          </Typography>
          <Typography>{t('ongoing-contests')}</Typography>
        </Box>
        <Box sx={{ textAlign: 'center' }}>
          <Typography sx={{ fontWeight: 'bold', fontSize: '18px' }}>
            {dashboardData.completedTenderCount}
          </Typography>
          <Typography>{t('winner-selected-contests')}</Typography>
        </Box>
      </Box>
    </>
  )
}
